// angular
// 	.module("HeroPRO")
// 	.directive('hpAch', achDirective);

export default function achDirective() {
    return {
        restrict: 'E',
        controller: 'AchController',
        controllerAs: 'ach',
        bindToController: true,
        scope: {
            cancelClick: '&',
            saveClick: '&?',
            achData: '=?',
            displayLogo: '=?',
            notificationView: '=?',

        },
        templateUrl: 'app/accounts/offices/financing/ach/ach.html',
        link() {
            console.log('ach');
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/financing/ach/achDirective.js